// Función auxiliar para calcular la letra de control
const getControlLetter = (number: number): string => {
    const letters = "TRWAGMYFPDXBNJZSQVHLCKE".split("");
    return letters[number % 23];
  };
 /* ----------------------------------------------- Validación DNI ------------------------------------------------------- */

export const ValidateDNI = (dni: string): boolean => {
  const dniRegex = /^[0-9]{8}[A-Z]$/;
  if (!dniRegex.test(dni)) return false; // Verificar formato básico

  const number = parseInt(dni.slice(0, 8)); // Obtener los primeros 8 dígitos
  const letter = dni.slice(-1); // Obtener la última letra
  const correctLetter = getControlLetter(number); // Calcular la letra correcta

  return correctLetter === letter; // Comparar las letras
};

/* ----------------------------------------------- Validación NIE ------------------------------------------------------- */

export const ValidateNIE = (nie: string): boolean => {
  const nieRegex = /^[XYZ]\d{7,8}[A-Z]$/;
  if (!nieRegex.test(nie)) return false; // Verificar formato básico

  const initialLetter = nie.charAt(0);
  const numberPart = nie.slice(1, -1);
  const finalLetter = nie.charAt(nie.length - 1);

  let prefix = 0;
  if (initialLetter === 'X') prefix = 0;
  else if (initialLetter === 'Y') prefix = 1;
  else if (initialLetter === 'Z') prefix = 2;

  const number = parseInt(prefix + numberPart, 10);
  const correctLetter = getControlLetter(number); // Calcular la letra correcta para NIE

  return correctLetter === finalLetter; // Comparar las letras
};

/* ----------------------------------------------- Validación CIF ------------------------------------------------------- */

export const ValidateCIF = (cif: string): boolean => {
  const regex = /^[A-Z]\d{7}[A-Z0-9]$/;
  if (!regex.test(cif)) return false; // Verificar formato básico

  const controlLetter = cif.charAt(0);
  const digits = cif.slice(1, -1).split('').map(Number);
  const controlDigit = cif.charAt(cif.length - 1);

  let sumEven = 0, sumOdd = 0;
  digits.forEach((digit, index) => {
    if (index % 2 === 0) {
      const double = digit * 2;
      sumOdd += double > 9 ? double - 9 : double;
    } else {
      sumEven += digit;
    }
  });

  const totalSum = sumEven + sumOdd;
  const checkDigit = (10 - (totalSum % 10)) % 10;

  // Comprobar el carácter de control
  if (controlLetter.match(/[ABEH]/)) {
    return checkDigit === Number(controlDigit);
  } else if (controlLetter.match(/[KPQS]/)) {
    return controlDigit === String.fromCharCode(64 + checkDigit);
  } else {
    return (
      checkDigit === Number(controlDigit) ||
      controlDigit === String.fromCharCode(64 + checkDigit)
    );
  }
};

/* ----------------------------------------------- Código Postal ------------------------------------------------------- */

export const isValidPostalCode = (postalCode: string): boolean => {
  // Eliminar espacios y caracteres no numéricos
  const sanitizedPostalCode = postalCode.replace(/\D/g, '');

  // Verificar que tenga exactamente 5 dígitos
  if (sanitizedPostalCode.length !== 5) {
    return false;
  }

  // Verificar que sea un número
  if (!/^\d{5}$/.test(sanitizedPostalCode)) {
    return false;
  }

  // Validación de códigos postales válidos en España (primeros dos dígitos)
  const validProvinces = [
    '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12',
    '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24',
    '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36',
    '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48',
    '49', '50', '51', '52'
  ];

  // Verificar que los dos primeros dígitos corresponden a una provincia válida
  const provinceCode = sanitizedPostalCode.slice(0, 2);
  if (!validProvinces.includes(provinceCode)) {
    return false;
  }

  return true;
};

/* ----------------------------------------------- Teléfono ------------------------------------------------------- */
export const isValidPhone = (phone: string): boolean => {
  
  // Eliminar cualquier carácter no numérico
  const libphonenumber = phone.replace(/\D/g, '');
  
  // Validar que tenga exactamente 9 dígitos y que empiece con 6, 7, o 9
  return libphonenumber.length === 9 && ['6', '7', '9'].includes(libphonenumber[0]);
};


/* ----------------------------------------------- Validación Email ------------------------------------------------------- */
export const isValidEmail = (email: string): boolean => {
  const emailRegex =
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};


/* ----------------------------------------------- Contraseña ------------------------------------------------------- */
export const isValidContrasena = (password: string): string | null => {
  if (!password) return "La contraseña es obligatoria";
  if (password.length < 6) return "La contraseña debe tener al menos 6 caracteres";
  if (password.length > 16) return "La contraseña no puede tener más de 16 caracteres";

  const regex = /^[A-Za-z0-9&#_]+$/;
  if (!regex.test(password)) return "Solo se permiten letras, números, &, # y _";

  return null;
};